import { DialogComponent, DialogOpenEvent, DialogCloseEvent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';
import { isMobileBreakpoint } from '@theme/utilities';

class CartDrawerComponent extends DialogComponent {
  #summaryThreshold = 0.5;
  #historyAbortController = null;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.addEventListener(DialogOpenEvent.eventName, this.#updateStickyState);
    this.addEventListener(DialogOpenEvent.eventName, this.#handleHistoryOpen);
    this.addEventListener(DialogCloseEvent.eventName, this.#handleHistoryClose);
    if (history.state?.cartDrawerOpen) { history.replaceState(null, ''); }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.removeEventListener(DialogOpenEvent.eventName, this.#updateStickyState);
    this.removeEventListener(DialogOpenEvent.eventName, this.#handleHistoryOpen);
    this.removeEventListener(DialogCloseEvent.eventName, this.#handleHistoryClose);
    this.#historyAbortController?.abort();
  }

  #handleHistoryOpen = () => {
    if (!isMobileBreakpoint()) return;
    if (!history.state?.cartDrawerOpen) { history.pushState({ cartDrawerOpen: true }, ''); }
    this.#historyAbortController = new AbortController();
    window.addEventListener('popstate', this.#handlePopState, { signal: this.#historyAbortController.signal });
  };

  #handleHistoryClose = () => {
    this.#historyAbortController?.abort();
    if (history.state?.cartDrawerOpen) { history.back(); }
  };

  #handlePopState = async () => {
    if (this.refs.dialog?.open) {
      this.refs.dialog.style.setProperty('--dialog-drawer-closing-animation', 'none');
      await this.closeDialog();
      this.refs.dialog.style.removeProperty('--dialog-drawer-closing-animation');
    }
  };

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) { this.showDialog(); }
  };

  open() {
    this.showDialog();
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() { this.closeDialog(); }

  #updateStickyState() {
    const { dialog } = this.refs;
    if (!dialog) return;
    const content = dialog.querySelector('.cart-drawer__content');
    const summary = dialog.querySelector('.cart-drawer__summary');
    if (!content || !summary) { dialog.setAttribute('cart-summary-sticky', 'false'); return; }
    const drawerHeight = dialog.getBoundingClientRect().height;
    const summaryHeight = summary.getBoundingClientRect().height;
    const ratio = summaryHeight / drawerHeight;
    dialog.setAttribute('cart-summary-sticky', ratio > this.#summaryThreshold ? 'false' : 'true');
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
(function() {
  var lastCartHashDrawer = '';

  function getCartHash(items) {
    return items.map(function(i) { return i.product_id + ':' + i.quantity; }).sort().join(',');
  }

  function populate(force) {
    var select = document.getElementById('delivery-date-select');
    var msg = document.getElementById('delivery-cutoff-msg');
    if (!select) return;

    var savedValue = select.value;

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cartData) {
        var s = document.getElementById('delivery-date-select');
        var m = document.getElementById('delivery-cutoff-msg');
        if (!s) return;

        var newHash = getCartHash(cartData.items);
        if (!force && newHash === lastCartHashDrawer && s.options.length > 0) return;
        lastCartHashDrawer = newHash;

        var cartItems = cartData.items;
        var isWelcome = cartItems.length > 0 && cartItems.every(function(item) {
          return item.properties && item.properties['_welcome_home'] === 'true';
        });
        var creditHandles = ['store-credit-top-up'];
        var onlyCredit = cartItems.length > 0 && cartItems.every(function(item) {
          return creditHandles.some(function(h) { return item.handle && item.handle.indexOf(h) > -1; });
        });

        s.innerHTML = '';

        if (isWelcome) {
          var opt = document.createElement('option');
          opt.value = 'Monday, 20 July 2026';
          opt.textContent = 'Monday, 20 July 2026';
          opt.selected = true;
          s.appendChild(opt);
          if (m) { m.textContent = 'Welcome Home delivery: Monday, 20 July 2026'; m.style.color = 'green'; }
        } else if (onlyCredit) {
          var opt2 = document.createElement('option');
          opt2.value = 'N/A - Digital delivery';
          opt2.textContent = 'N/A — Digital delivery';
          opt2.selected = true;
          s.appendChild(opt2);
          if (m) { m.textContent = 'Store credit is delivered digitally — no delivery date needed.'; m.style.color = 'green'; }
        } else {
          var now = new Date();
          var utc = now.getTime() + (now.getTimezoneOffset() * 60000);
          var sast = new Date(utc + 7200000);
          var day = sast.getDay();
          var hours = sast.getHours();
          var mins = sast.getMinutes();
          var cutoffPassed = (day === 1 && (hours > 10 || (hours === 10 && mins > 0)));
var weekOffset = cutoffPassed ? 1 : 0;
          if (m) {
            m.textContent = weekOffset === 0 ? 'Order before Monday 10:00 — deliverable this Thursday!' : 'Cutoff passed — earliest delivery is next Thursday.';
            m.style.color = weekOffset === 0 ? 'green' : '#e67e00';
          }
          var daysToThursday = (4 - day + 7) % 7;
          if (daysToThursday === 0) daysToThursday = 7;
          var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
          for (var i = 0; i < 8; i++) {
            var totalDays = daysToThursday + (weekOffset * 7) + (i * 7);
            var thursday = new Date(sast.getTime() + totalDays * 86400000);
            var option = document.createElement('option');
            option.value = 'Thursday, ' + thursday.getDate() + ' ' + months[thursday.getMonth()];
            option.textContent = option.value;
            s.appendChild(option);
          }
          if (savedValue) {
            for (var j = 0; j < s.options.length; j++) {
              if (s.options[j].value === savedValue) { s.selectedIndex = j; break; }
            }
          }
        }
      })
      .catch(function() {});
  }

  if (document.readyState !== 'loading') { populate(true); }
  else { document.addEventListener('DOMContentLoaded', function() { populate(true); }); }

  document.addEventListener('cart:updated', function() { populate(false); });
  document.addEventListener('cart:refresh', function() { populate(false); });
  document.addEventListener('dialog:open', function() { setTimeout(function() { populate(true); }, 300); }, true);

  var dialogObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mut) {
      if (mut.attributeName === 'open') {
        var el = mut.target;
        if (el.tagName === 'DIALOG' && el.open) { setTimeout(function() { populate(true); }, 300); }
      }
    });
  });
  dialogObserver.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
})();

// Cart conflict interceptor — hooks into cart:update after theme adds item
(function() {
  var WELCOME_HOME_HANDLE = 'welcome-home-monday-20-july-2026';
  var welcomeHomeProductIds = null;
  var intercepting = false;

  function getWelcomeHomeProductIds() {
    if (welcomeHomeProductIds !== null) return Promise.resolve(welcomeHomeProductIds);
    return fetch('/collections/' + WELCOME_HOME_HANDLE + '/products.json?limit=250')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        welcomeHomeProductIds = data.products.map(function(p) { return p.id; });
        return welcomeHomeProductIds;
      })
      .catch(function() { welcomeHomeProductIds = []; return []; });
  }

  function showConflictMessage(message, onClearAndAdd) {
    var existing = document.getElementById('vars-cart-conflict-msg');
    if (existing) existing.remove();

    var div = document.createElement('div');
    div.id = 'vars-cart-conflict-msg';
    div.style.cssText = 'position:fixed;top:20px;left:50%;transform:translateX(-50%);z-index:99999;background:#fff;border:2px solid #e67e00;border-radius:8px;padding:16px 20px;max-width:380px;width:90%;box-shadow:0 4px 20px rgba(0,0,0,0.15);font-size:14px;line-height:1.5;text-align:center;';
    div.innerHTML = '<p style="margin:0 0 12px;color:#333;">' + message + '</p>' +
      '<div style="display:flex;gap:8px;justify-content:center;">' +
      '<button id="vars-conflict-clear" style="padding:8px 16px;background:#e67e00;color:#fff;border:none;border-radius:4px;cursor:pointer;font-size:13px;font-weight:600;">Clear cart &amp; add</button>' +
      '<button id="vars-conflict-cancel" style="padding:8px 16px;background:#f5f5f5;color:#333;border:1px solid #ccc;border-radius:4px;cursor:pointer;font-size:13px;">Keep current cart</button>' +
      '</div>';

    document.body.appendChild(div);

    document.getElementById('vars-conflict-cancel').addEventListener('click', function() { div.remove(); });
    document.getElementById('vars-conflict-clear').addEventListener('click', function() {
      div.remove();
      if (onClearAndAdd) onClearAndAdd();
    });

    setTimeout(function() { if (div.parentNode) div.remove(); }, 10000);
  }

  document.addEventListener('cart:update', function(e) {
    if (intercepting) return;

    var detail = (e.detail && e.detail.data) || {};
    if (detail.didError) return;
    if (detail.source === 'vars-conflict-interceptor') return;

    var productId = detail.productId ? parseInt(detail.productId, 10) : null;
    if (!productId) return;

    getWelcomeHomeProductIds().then(function(whIds) {
      return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        var cartItems = cart.items;
        if (cartItems.length <= 1) return; // only one item, no conflict possible

        var addingIsWelcome = whIds.indexOf(productId) > -1;
        var otherItems = cartItems.filter(function(item) { return item.product_id !== productId; });
        var othersHaveWelcome = otherItems.some(function(item) { return whIds.indexOf(item.product_id) > -1; });
        var othersHaveNormal = otherItems.some(function(item) { return whIds.indexOf(item.product_id) === -1; });

        var conflict = (addingIsWelcome && othersHaveNormal) || (!addingIsWelcome && othersHaveWelcome);
        if (!conflict) return;

        // Find the just-added item to remove it
        var justAdded = cartItems.find(function(item) { return item.product_id === productId; });
        if (!justAdded) return;

        intercepting = true;

        // Remove the conflicting item immediately
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: justAdded.key, quantity: 0 })
        }).then(function() {
          intercepting = false;
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          var msg = addingIsWelcome
            ? '⚠️ Welcome Home items must be ordered separately. Your cart has regular products in it. Clear your cart and add this Welcome Home item instead?'
            : '⚠️ Your cart has Welcome Home items (Monday 20 July delivery). Regular products must be ordered separately. Clear your cart and add this item instead?';

          var savedVariantId = justAdded.variant_id;
          var savedQuantity = justAdded.quantity;

          showConflictMessage(msg, function() {
            intercepting = true;
            fetch('/cart/clear.js', { method: 'POST' })
              .then(function() {
                return fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: savedVariantId, quantity: savedQuantity })
                });
              })
              .then(function() {
                intercepting = false;
                document.dispatchEvent(new CustomEvent('cart:refresh'));
              })
              .catch(function() { intercepting = false; });
          });
        }).catch(function() { intercepting = false; });
      });
    }).catch(function() {});
  }, true);

  getWelcomeHomeProductIds();
})();
